import styled from "styled-components";
import { Modal } from "antd";
import { theme } from "../../../config";
import { Props } from "./Modal";
import { CloseCircleFilled as AntCloseCircleFilled } from "@ant-design/icons";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 4px;

    @media ${theme.breakpoints.mobileAndTablet} {
      border-radius: 0;
      margin: -8px;
      margin-bottom: -32px;
    }
  }

  .ant-modal-body {
    padding: 32px 41px 41px 41px;
    height: ${(props: Props) => (props.height ? props.height : "auto")};
    overflow: ${(props: Props) => (props.height ? "scroll" : "auto")};
    overflow-x: hidden;
  }
`;

export const Title = styled.p`
  font-family: Orkney Bold;
  font-size: 22px;
  line-height: 32px;
  color: #111111;
`;

export const CloseCircleFilled = styled(AntCloseCircleFilled)`
  font-size: 21px;
  @media ${theme.breakpoints.pcAndTablet} {
    margin: 32px 40px 0px 0px;
  }
`;
